import {
  PLAN_COMPARE_SCENARIO_DOT,
  accent,
  neutral,
  text as textToken,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';
import { primaryAction } from 'styles/revampTokens';

/**
 * Colours for the Data module, taken from the same tokens the revamped Plan
 * page draws with (neutral chrome, purple only where something is active), so
 * the two pages can't drift apart.
 */
const dataColors = {
  surface: neutral.surface,
  headerBg: neutral.surfaceMuted,
  hover: neutral.surfaceHover,
  border: neutral.border,
  textDark: textToken.primary,
  textSecondary: textToken.secondary,
  activeBg: accent.subtle,
  primary: accent.solid,
  action: primaryAction.bg,
  actionHover: primaryAction.hover,
  primaryHover: accent.hover,
  white: textToken.inverse,
  success: PLAN_COMPARE_SCENARIO_DOT,
  danger: '#E23F3F',
  warning: '#B45309',
} as const;

export default dataColors;
